import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Webcam from '../../components/webcam'
import WebcamButton from '../../components/webcam-button'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch'
import { handleScan, handleError, toggleWebcam, webcamLoaded, flipWebcam } from '../../reducers/scan'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress'
import Icon from '@material-ui/core/Icon'
import { STATE } from '../../util/constants'
const styles = theme => ({
  root: {
    flexGrow: 1
  },
  card: {
    padding: theme.spacing.unit,
    margin: theme.spacing.unit
  },
  item: {
    width: '80%',
    maxWidth: 345
  },
  toggle: {
    padding: theme.spacing.unit
  },
  progress: {
    margin: theme.spacing.unit
  },
  webcam: {
    padding: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 2
  },
  result: {
    display: 'flex',
    justifyContent: 'center'
  },
  icon: { margin: '10%' }
});
const spacing = '16'

const ScanPage = (props) => {
  const { classes, toggleWebcam, webcamLoaded, handleScan, handleError, enabled, loaded, scanned, code, front, flipWebcam, checkResult } = props
  return (
    <div>
      <WebcamButton onClick={toggleWebcam} scanned={scanned} enabled={enabled} />
      <Dialog
        open={enabled}
        onClose={toggleWebcam}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Scan Pass</DialogTitle>
        <DialogContent>
          <div className={classes.webcam}>
            <Webcam handleScan={handleScan} handleError={handleError} enabled={enabled} loaded={loaded} webcamLoaded={webcamLoaded} front={front} />
          </div>
          <DialogContentText>
            Position the QR code in the center of the camera's field of view
            </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Switch onClick={flipWebcam} checked={front} value="checkedF" color="default" />
          <Button onClick={toggleWebcam} color="primary">
            Cancel
            </Button>
        </DialogActions>
      </Dialog>
      <Grid container spacing={16} className={classes.root}>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={Number(spacing)}>
            <Grid key={0} item className={classes.item}>
              <Card key={0} className={classes.card}>
                <CardContent>
                  <Typography gutterBottom variant="headline" component="h2">
                    Result
                  </Typography>
                  <div className={classes.result}>
                    <Icon style={{ fontSize: 72 }} color={checkResult === STATE.PASS ? "primary" : "disabled"} className={classes.icon}>
                      check
                    </Icon>
                    <Icon style={{ fontSize: 72 }} color={checkResult === STATE.FAIL ? "primary" : "disabled"} className={classes.icon}>
                      close
                    </Icon>
                  </div>
                  <div className={classes.progress}>
                    {checkResult === STATE.PENDING ?
                      <LinearProgress />
                      : ""
                    }
                  </div>
                </CardContent>
              </Card>
            </Grid>
            {!!code ?
              <Grid key={1} item className={classes.item}>
                <Card key={0} className={classes.card}>
                  <CardContent>
                    <Typography component="p">
                      {code}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              : ""}
          </Grid>
        </Grid>
      </Grid >
    </div>
  );
}
ScanPage.propTypes = {
  classes: PropTypes.object.isRequired,
  code: PropTypes.string.isRequired,
  scanned: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  toggleWebcam: PropTypes.func.isRequired,
  handleScan: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  webcamLoaded: PropTypes.func.isRequired,
  flipWebcam: PropTypes.func.isRequired,
  checkResult: PropTypes.string.isRequired
};
const mapStateToProps = ({ scan }) => ({
  enabled: scan.enabled,
  loaded: scan.loaded,
  scanned: scan.scanned,
  code: scan.result.code,
  front: scan.front,
  checkResult: scan.result.state
});
const mapDispatchToProps = dispatch => bindActionCreators({
  toggleWebcam,
  webcamLoaded,
  handleScan,
  handleError,
  flipWebcam
}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ScanPage))



// WEBPACK FOOTER //
// ./src/pages/scan/index.js